import _ from 'lodash';
import db from '../../config/databases/forms';
import { fillForm } from '../../config/configuration/react';
import { store } from '../../Store/store';
import { REACT_APP_API } from '../../config';
import { Record } from '../../config/Record/RecordEntity';

export default async function getFormLocal(formId) {
  const _formId = parseInt(formId, 10);
  const form = await db.forms.get(_formId);
  if (form === undefined) return 'IDB_FORM_DONT_EXIST';
  return form;
}

const questions = [
  { section: 'admin_infos', question: 'vat' },
  { section: 'admin_infos', question: 'leasing' },
  { section: 'admin_infos', question: 'vehicule_type' },
  { section: 'admin_infos', question: 'imported_expertise' },
  { section: 'admin_infos', question: 'origin' },
  { section: 'servicing_infos', question: 'servicing_history' },
  { section: 'servicing_infos', question: 'servicing_in_brand_network' },
  { section: 'servicing_infos', question: 'last_servicing_date' },
  { section: 'servicing_infos', question: 'last_servicing_km' },
  { section: 'body', question: 'vehicule_paint_metal' },
  { section: 'body', question: 'color' },
  { section: 'wheels', question: 'wheels_front_age' },
  { section: 'wheels', question: 'wheels_front_dimensions' },
  { section: 'wheels', question: 'wheels_front_tire_type' },
  { section: 'wheels', question: 'wheels_front_tire_brand' },
  { section: 'wheels', question: 'wheels_front_rim_type' },
  { section: 'wheels', question: 'wheels_back_age' },
  { section: 'wheels', question: 'wheels_back_dimensions' },
  { section: 'wheels', question: 'wheels_back_tire_type' },
  { section: 'wheels', question: 'wheels_back_tire_brand' },
  { section: 'wheels', question: 'wheels_back_rim_type' },
  { section: 'inside', question: 'inside_color' },
  { section: 'inside', question: 'interior_coating' },
  { section: 'road_test', question: 'air_conditionner' },
  { section: 'road_test', question: 'equipments' },
];

export async function copyAnswers(form) {
  const recordId = form?.recordId;
  const state = store.getState();
  const record = _.get(state, `reduxRecords.data[${recordId}]`);
  const recordEntity = new Record(record);
  const recordTypeId = recordEntity.type();
  const initialInspectionAvailable = _.has(state, `reduxRecords.data[${recordId}].counterInspection`);
  if (recordTypeId === 2 && initialInspectionAvailable) {
    const initialRecordKey = _.get(state, `reduxRecords.data[${recordId}].counterInspection.recordKey`, null);
    if (initialRecordKey) {
      try {
        const response = await fetch(`${REACT_APP_API}/buyer/public/records/${initialRecordKey}`);
        const data = await response.json();
        const initialInspection = data?.inspection;
        if (initialInspection) {
          questions.forEach(({ section, question }) => {
            const questionPath = `inspection.children.${section}.children.${question}`;
            const initialValue = _.get(initialInspection, `children.${section}.children.${question}.value`, null);
            if (
              _.has(form, questionPath) &&
              _.get(form?.inspection, `children.${section}.children.${question}.value`) === undefined &&
              initialValue !== null
            ) {
              _.set(form, `${questionPath}.value`, initialValue);
              fillForm.saveValue(form.id, `${questionPath}.value`, initialValue, question, question.type);
            }
          });
        }
      } catch (e) {
        console.error(e.message);
      }
    }
  }
}
